import axios from "axios";
import { logout } from "../store/user/userActions";
import { BASE_URL } from '../CONSTANTS'

const instance = axios.create({
  baseURL: BASE_URL
});
export const setupInterceptors =(navigate,dispatch)=>{
  instance.interceptors.request.use(function(request){
    return request;
  })
  instance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    
    const redirectToLoginCodes = [400,401,403]
    if (redirectToLoginCodes.includes(error.response.status)){
      dispatch(logout())
    }
    return Promise.reject(error);
  })
}

export default instance;